export const PATH = {
  home: '/',
  ads: '/till-salu',
  login: '/logga-in',
  autoLogin: '/auto-login',
  mapstat: '/mapstat',
  residentialRegistry: '/bostadsregistret',
  indexViewer: '/index',
  market: '/marknad',
  notFound: '/sidan-hittades-inte',
  priceDevelopment: '/prisutveckling',
  project: '/vardering',
  pdf: '/pdf',
  sold: '/salda',
  projects: '/sparade-varderingar',
};

